module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_24.93068994.png";